import {Directive} from '@angular/core';
import {FormControl, NG_VALIDATORS} from '@angular/forms';

function hasNumber(password) {
  return /\d/.test(password);
}

function hasLowerCase(str) {
  return (/[a-z]/.test(str));
}

function hasUpperCase(str) {
  return (/[A-Z]/.test(str));
}

function minimumLength(str) {
  return str.length < 8;
}

function hasSpecialChars(str) {
   return /[ _~`@.!#$%\^&*+=\-\[\]\\';,/(){}|\\":<>\?]/g.test(str);
}

function startsOrEndsWithWhitespace(str) {
  return /^\s|\s$/.test(str);
}

export function passwordStrengthValidator(control: FormControl) {
  const password = control.value;

  const missingTypes = {};
  if (!hasNumber(password)) {
    missingTypes['numbers'] = true;
  }
  if (!hasLowerCase(password)) {
    missingTypes['lowerCase'] = true;
  }
  if (!hasUpperCase(password)) {
    missingTypes['upperCase'] = true;
  }

  if (minimumLength(password)) {
    missingTypes['minimumLength'] = true;
  }

  if (!hasSpecialChars(password)) {
    missingTypes['specialCharacters'] = true;
  }
  if (startsOrEndsWithWhitespace(password)) {
    missingTypes['spaces'] = true;
  }
  return missingTypes;
}

@Directive({
    selector: '[adminPasswordStrengthValidator][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useValue: passwordStrengthValidator, multi: true }
    ],
    standalone: false
})
export class PasswordStrengthValidatorDirective {

  constructor() {
  }

}
